export default __webpack_public_path__ + "static/media/camera-portrait.7bfc6128.png";